import { Module } from './base';
import { getTranslation } from "../components/i18n";
import SettingsPersistor from "../components/settings-persistor";

class ReadingAidModule implements Module {
  name = 'reading-aid';

  setup(a11ySettings: Record<string, any>, modulesContainer: HTMLElement) {
    const moduleName = this.name;
    let styleContents = `
      #${moduleName} {
        position: fixed;
        left: 0;
        width: 100%;
        max-width: 100vw;
        height: 2px;
        background-color: red;
        pointer-events: none;
        z-index: var(--a11y-z-index);
        display: none;
      }
    `;
    const readingAidControls = document.createElement("div");
    readingAidControls.className = `a11y-module a11y-module-${moduleName}`;
    readingAidControls.innerHTML = `
      <label id="a11y-${moduleName}-label" for="toggle-${moduleName}" data-translation-field="true" data-translation-key="readingAid">${getTranslation('readingAid')}</label>
      <label class="a11y-toggle" tabindex="0" aria-labelledby="a11y-${moduleName}-label a11y-${moduleName}-label-text">
        <span id="a11y-${moduleName}-label-text" class="screen-reader-text">Die Option ist <span class="toggle-state-text"></span></span>
        <input id="toggle-${moduleName}" type="checkbox" tabindex="-1">
        <span class="slider"></span>
      </label>
    `;
    modulesContainer.appendChild(readingAidControls);
    const readingAidElement = document.createElement("div");
    readingAidElement.className = moduleName;
    readingAidElement.id = moduleName;
    document.body.appendChild(readingAidElement);
    function updateReadingAidPosition(e: MouseEvent) {
      readingAidElement.style.top = `${e.clientY}px`;
    }
    const toggleReadingAid = (toggle: boolean) => {
      if (toggle) {
        readingAidElement.style.display = 'block';
        document.addEventListener('mousemove', updateReadingAidPosition);
      } else {
        readingAidElement.style.display = 'none';
        document.removeEventListener('mousemove', updateReadingAidPosition);
      }
    };
    const readingAidToggle = document.getElementById(`toggle-${moduleName}`) as HTMLInputElement;
    const toggleStateText = readingAidControls.querySelector(`.toggle-state-text`) as HTMLSpanElement;
    readingAidToggle.addEventListener("click", (event) => {
      toggleReadingAid(readingAidToggle.checked);
      toggleStateText.innerText = readingAidToggle.checked ? 'aktiviert' : 'deaktiviert';
      if (readingAidToggle.checked) {
        updateReadingAidPosition(event);
      }
      SettingsPersistor.save(moduleName, readingAidToggle.checked);
    });
    toggleStateText.innerText = a11ySettings[moduleName] ? 'aktiviert' : 'deaktiviert';
    if (a11ySettings[moduleName]) {
      readingAidToggle.checked = a11ySettings[moduleName];
      readingAidElement.style.display = readingAidToggle.checked ? 'block' : 'none';
      toggleReadingAid(readingAidToggle.checked);
    }
    return styleContents;
  }

  reset() {
    const toggle = document.getElementById('toggle-reading-aid') as HTMLInputElement;
    const readingAidElement = document.getElementById('reading-aid');
    if (toggle) {
      toggle.checked = false;
      toggle.dispatchEvent(new Event('click'));
    }
    if (readingAidElement) {
      readingAidElement.style.display = 'none';
    }
  }
}

export default new ReadingAidModule();